import { ActionTree, GetterTree, MutationTree } from "vuex"
import Vue from "vue"

export interface ColorRule {
  id: number;
  colorCodeHex: string;
}

export interface CalendarColorSettings {
  reservationStatusColors?: ColorRule[];
  reservationDistributionChannelColors?: ColorRule[];
  reservationOtaColors?: ColorRule[];
  reservationSalesChannelColors?: ColorRule[];

  colorBasedOn?: CalendarColorByOptions;
  useReservationColorOverride?: boolean;
  useOtaChannelColorOverride?: boolean;
  useSalesChannelColorOverride?: boolean;
}

export type CalendarColorByOptions = "status" | "distributionChannel";

const initialState = {
  calendarColorSettings: {
    reservationStatusColors: [],
    reservationDistributionChannelColors: [],
    reservationOtaColors: [],
    reservationSalesChannelColors: [],
    colorBasedOn: "status",
    useReservationColorOverride: true,
    useOtaChannelColorOverride: true,
    useSalesChannelColorOverride: true
  } as CalendarColorSettings
}

const state = { ...initialState }

const getters: GetterTree<typeof state, any> = {
  calendarColorSettings: (state) => state.calendarColorSettings
}

const actions: ActionTree<typeof state, any> = {
  refreshCalendarColorSettings({ commit, rootGetters }) {
    return Vue.axios
      .get<CalendarColorSettings>("calendar/GetCalendarColorSettings")
      .then((res) => {
        const utid = rootGetters["auth/claims"]?.utid;
        const savedSettings = JSON.parse(localStorage.getItem(`pms.utid_${utid}_calendar_color_settings`) || "{}");
        commit("setCalendarColorSettings", {
          value: {
            ...savedSettings,
            ...res.data
          }, utid: utid
        });
      });
  },
  updateCalendarColorSettings: ({ commit, rootGetters }, payload: CalendarColorSettings) => {
    const utid = rootGetters["auth/claims"]?.utid;
    commit("setCalendarColorSettings", { value: payload, utid: utid });
  },
}

const mutations: MutationTree<typeof state> = {
  setCalendarColorSettings: (state, payload: { value: CalendarColorSettings, utid: any }) => {
    state.calendarColorSettings = {
      ...state.calendarColorSettings,
      ...payload.value
    }

    localStorage.setItem(`pms.utid_${payload.utid}_calendar_color_settings`, JSON.stringify(state.calendarColorSettings));
  },
}

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations,
}